/* globals ucCommonLogin */
import {ucDomain, ucAppID, passDomain, ucReg} from '@/common/util';
import CheckProtocol from '@/component/CheckProtocol';
import Vue from 'vue';

const checkProtocolDom = dom => {
    if (dom == null) {
        return;
    }
    // 创建一个新的div节点
    let bindComponent = document.createElement('div');
    // 给创建的div设置id，并且添加到指定的DOM后
    bindComponent.setAttribute('id', 'checker');
    dom.appendChild(bindComponent);

    // 这里我们return一个新的Vue实例并且将实例挂载到我们刚创建的DOM节点上
    return new Vue({
        render: h => {
            return h(
                CheckProtocol
            );
        }
    }).$mount('#checker');
};
export default {
    injected: ['$toast'],
    computed: {
        isPassport() {
            // const query = this.$route.query;
            const hags = this.$store.state.app.userInfo.bizHags || {};
            return hags.digital_is_passport;
        }
    },
    mounted() {
        // 延迟进行初始化，确保dom ready，进行魔方和登录框的显隐切换
        setTimeout(() => {
            this.initLogin();
            this.hideLoginAndShowCube();
        }, 10);

        // 延迟绑定监听，确保比初始化动作晚启动，如果页面位于底部，可触发初始隐藏登录逻辑
        setTimeout(() => {
            this.observeHeader();
        }, 30);
        console.log(ucDomain, passDomain);
    },
    methods: {
        // 显示登录框、隐藏魔方
        showLoginAndHideCube() {
            const loginDom = document.querySelector('#cc-home-login-container');
            if (loginDom) {
                loginDom.style.display = 'block';
            }
            const cubeDom = document.querySelector('.bg-video-cube');
            if (cubeDom) {
                cubeDom.style.display = 'none';
            }
        },
        // 隐藏登录框、显示魔方
        hideLoginAndShowCube() {
            const loginDom = document.querySelector('#cc-home-login-container');
            if (loginDom) {
                loginDom.style.display = 'none';
            }
            const cubeDom = document.querySelector('.bg-video-cube');
            if (cubeDom) {
                cubeDom.style.display = 'block';
            }
        },
        // 监听页面滚动是否已经离开了首屏，需要隐藏登录框
        observeHeader() {
            // 监听页面滚动直到登录框无法显示，则登录框自动消失，需要回到顶部后点击登录按钮才会再次出现
            // 创建IntersectionObserver实例，并传入回调函数和配置对象
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0
            };
            const observer = new IntersectionObserver(callback, options);
            // 回调函数
            function callback(entries, observer) {
                entries.forEach(entry => {
                    // 目标元素离开视窗，此时把登录框隐藏，魔方显示出来
                    if (!entry.isIntersecting) {
                        const loginDom = document.querySelector('#cc-home-login-container');
                        if (loginDom) {
                            loginDom.style.display = 'none';
                        }
                        const cubeDom = document.querySelector('.bg-video-cube');
                        if (cubeDom) {
                            cubeDom.style.display = 'block';
                        }
                    }
                });
            }
            // 将目标元素添加到观察器中
            const target = document.querySelector('.cc-sub-container');
            if (target == null) {
                return;
            }
            observer.observe(target);
        },
        initLogin() {
            const {origin, pathname} = window.location;
            const fromU = encodeURIComponent(origin);
            const loginDom = document.querySelector('#cc-home-login-container');
            // dom不存在，不要初始化
            if (!loginDom) {
                return false;
            }
            ucCommonLogin.init({
                // 产品线ID 使用 http://iuc.baidu.com/ 申请
                appid: ucAppID,
                staticPage: `${origin}/static/v3Jump.html`,
                // 暂时只显示pass登录，双登录的话默认tab改成uc
                multiLogin: 1,
                container: 'cc-home-login-container',
                defaultLogin: 'uc',
                isCanCodeLogin: true,
                product: 'www2',
                defaultCss: 1,
                defaultCssVersion: 3,
                passUseOptions: {
                    loginVersion: 'v4'
                },
                passLoginOptions: {
                    sms: 5,
                    userPwdLogin: 1
                },
                isLayer: 0,
                proxyUc: true,
                registerUcLink: `${ucReg}/?tpl=www2&fromu=${fromU}`,
                registerPassLink: `${passDomain}/v2/?reg&u=${fromU}`,
                success: opts => {
                    const ucLogin = ucDomain;
                    let href = '';
                    const newPath = '/index';
                    // 登录完成后默认都应该回到登录后的首页
                    if (opts.type === 'passport') {
                        const hairuoMainUrl = `${origin}/hairuo/main.do?rurl=${encodeURIComponent(newPath)}`;
                        href = `${ucLogin}/?action=psUcLogin&appid=${ucAppID}&u=${encodeURIComponent(hairuoMainUrl)}`;
                    }
                    else {
                        href = `${origin}/hairuo/main.do?rurl=${encodeURIComponent(newPath)}`;
                    }
                    // 每次登陆后都清除之前的返回旧版的标记
                    window.sessionStorage.removeItem('style_click_old');
                    console.log(href);
                    location.href = href;
                },
                rendered: item => {
                    const {passportInstance} = item;
                    if (!passportInstance) {
                        return;
                    }
                    passportInstance?.on('beforeSubmit', args => {
                        if (window.isCheckProtocol) {
                            args.returnValue = true;
                        }
                        else {
                            this.$toast.warn('请先阅读并同意《擎舵平台用户服务协议》');
                            args.returnValue = false;
                        }
                    });
                    const dom1 = document.querySelector('#TANGRAM__PSP_4__submitWrapper');
                    const dom2 = document.querySelector('#TANGRAM__PSP_4__smsSubmitWrapper');
                    checkProtocolDom(dom1); // 勾选协议挂载到dom上
                    checkProtocolDom(dom2); // 勾选协议挂载到dom上
                }
            });
            ucCommonLogin.hide();
        }
    }
};
